<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<!--  Баблы внутренних табов  -->
<div class="bubble-container head">
    <button [class.selected]="tab === 0"
            (click)="tab = 0"
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.MAIN' | translate }}
    </button>
    <button [class.selected]="tab === 1"
            (click)="tab = 1"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.STATISTICS' | translate }}
    </button>
    <button [class.selected]="tab === 2"
            (click)="tab = 2"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.HISTORY' | translate }}
    </button>
</div>


@switch (tab) {
    @case (0) {
        <div class="table-container">

            <!--    Статистика по всем контрактам    -->
            <div class="widget-container column-4 rows-2">
                @if (statisticData) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.CONTRACTS.WIDGET_HEADERS.STATISTICS' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getStatistic()"
                        ></i>
                    </div>
                    <div class="widget-body contracts-statistic">
                        <div>
                            <span>{{ 'INDEX_PAGE.CONTRACTS.TEXT.NEW' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.open }}
                                </span>
                            </div>
                        </div>

                        <div>
                            <span>{{ 'INDEX_PAGE.CONTRACTS.TEXT.IN_PROGRESS' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.verified }}
                                </span>
                            </div>
                        </div>

                        <div>
                            <span>{{ 'INDEX_PAGE.CONTRACTS.TEXT.COMPLETED' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.completed }}
                                </span>
                            </div>
                        </div>

                        <div>
                            <span>{{ 'INDEX_PAGE.CONTRACTS.TEXT.ARCHIVED' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.closed }}
                                </span>
                            </div>
                        </div>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--  Статика предложения продуктов банка  -->
            <div class="widget-container mini-ads column-2">
                <h2>Инвестиции</h2>
                <section>
                    <img src="assets/images/ads/invest.png" alt="#" width="101" height="87">
                </section>
            </div>

            <div class="widget-container mini-ads column-2">
                <h2>Вклады</h2>
                <section>
                    <img src="assets/images/ads/safe.png" alt="#" width="101" height="67">
                </section>
            </div>

            <div class="widget-container mini-ads column-2">
                <h2>Кредитование</h2>
                <section>
                    <img src="assets/images/ads/calc.png" alt="#" width="80" height="77">
                </section>
            </div>
            <!--     Кнопки END       -->

            <!--  Рекламное предложение  -->
            <div class="widget-container column-6">
                <div class="widget-body row-ads">
                    <div>
                        <div style="display: flex; align-items: center;">
                            <span>{{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.TITLE' | translate }}</span>
                            <span class="big">3 950 000 ₽</span>
                        </div>
                        <small class="light">{{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.DAY' | translate }}</small>
                        <div class="main-ads">
                            <div style="margin-right: 30px;">
                                <span>240 220 ₽</span><br>
                                <small class="light">{{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.PAY' | translate }}</small>
                            </div>
                            <div class="middle">
                                <span>{{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.PERCENT' | translate }}</span><br>
                                <small class="light">{{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.RATE' | translate }}</small>
                            </div>
                            <div style="margin-left: 30px;">
                                <span>0%</span><br>
                                <small class="light">{{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.COMMISSION' | translate }}</small>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button class="button blue"><i class="ri-wallet-2-fill"></i>
                            {{ 'INDEX_PAGE.CONTRACTS.TEXT.ADS.SEND' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!--  Таблица контрактов  -->
            <div class="widget-container column-5">
                @if (allParsedContracts) {
                    <div class="widget-header">
                        <h2>
                            {{ 'INDEX_PAGE.CONTRACTS.WIDGET_HEADERS.CONTRACTS' | translate }}
                            <span class="info-bubble">{{ allParsedContracts.allContracts.length }}</span>
                        </h2>
                        <i class="ri-refresh-line"
                           (click)="getAllContracts()"
                        ></i>
                    </div>
                    <div class="widget-body">
                        <div class="bubble-container">
                            <button [class.selected]="allParsedContracts.contractsTab === 'allContracts'"
                                    (click)="allParsedContracts.contractsTab = 'allContracts'"
                            >
                                {{ 'INDEX_PAGE.CONTRACTS.BUBBLES_TEXT.ALL' | translate }}
                            </button>
                            <button [class.selected]="allParsedContracts.contractsTab === 'newContracts'"
                                    (click)="allParsedContracts.contractsTab = 'newContracts'"
                            >
                                {{ 'INDEX_PAGE.CONTRACTS.BUBBLES_TEXT.NEW' | translate }}
                            </button>
                            <button [class.selected]="allParsedContracts.contractsTab === 'workContracts'"
                                    (click)="allParsedContracts.contractsTab = 'workContracts'"
                            >
                                {{ 'INDEX_PAGE.CONTRACTS.BUBBLES_TEXT.IN_PROGRESS' | translate }}
                            </button>
                            <button [class.selected]="allParsedContracts.contractsTab === 'completedContracts'"
                                    (click)="allParsedContracts.contractsTab = 'completedContracts'"
                            >
                                {{ 'INDEX_PAGE.CONTRACTS.BUBBLES_TEXT.COMPLETED' | translate }}
                            </button>

                            <button [class.selected]="allParsedContracts.contractsTab === 'archivedContracts'"
                                    (click)="allParsedContracts.contractsTab = 'archivedContracts'"
                            >
                                {{ 'INDEX_PAGE.CONTRACTS.BUBBLES_TEXT.ARCHIVED' | translate }}
                            </button>
                        </div>

                        <div class="contracts-table">
                            @for (contract of allParsedContracts[allParsedContracts.contractsTab]; track contract.guid) {
                                <div class="contract-item" (click)="goTo(contract)">
                                    <div class="header">
                                        <i class="ri-time-line"></i> {{ contract.created_at | date:'dd.MM.yy HH:mm' }}
                                    </div>
                                    <div class="body">{{ contract.name }}</div>
                                </div>
                            } @empty {
                                <div>{{ 'EMPTY_LISTS.CONTRACTS' | translate }}</div>
                            }
                        </div>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--  Календарь  -->
            <div class="widget-container column-5">
                @if (calendarLegend) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.CONTRACTS.WIDGET_HEADERS.CALENDAR' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getAllContracts()"
                        ></i>
                    </div>
                    <div class="widget-body calendar-widget">
                        <app-calendar
                                [monthDate]="current"
                                [items]="itemsMap"
                                [calendarLegend]="calendarLegend"
                                [maxItemsPerCell]="3"
                                [disableNextMonth]="true"
                                (monthChange)="onAddItems($event[0], $event[1])"
                                (dayClick)="onDayClick($event)"
                                (itemClick)="onItemClick($event)"
                        >
                        </app-calendar>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        </div>
    }
    @case (1) {
        Тут статистика
    }
    @case (2) {
        тут история
    }
}
